<template>
  <div class="page">
    <summary-header isHead />
    <summary-top>
      <summary-name :userNick="userNick" :userEmail="userEmail" />
    </summary-top>
    <v-container class="contents">
      <v-row dense>
        <v-col cols="4">
          <v-card tile elevation="0" flat>
            <div class="d-flex mt-3">
              <div class="section-title">Review</div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pl-0 pt-3 pb-0">
              <p class="question mb-1">
                지금까지 살아 온
                <span class="subtitle-2">나의 삶</span>
                은?
              </p>
              <p class="text-h6 mb-0 ans">{{ (this.master['Master-openEnded-1'] || {}).value || '' }} 삶이었다.</p>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col>
          <v-card tile elevation="0" flat>
            <div class="d-flex mt-3">
              <div class="section-title">Vision</div>
              <div class="section-title-border"></div>
            </div>
            <v-card-text class="pl-0 pt-3 pb-0">
              <v-row>
                <v-col cols="6">
                  <p class="question mb-1">
                    내가 생각하는
                    <span class="subtitle-2">행복한</span>
                    삶이란?
                  </p>
                  <p class="text-h6 mb-0 ans">{{ (this.master['Master-openEnded-2'] || {}).value || '' }}삶이다.</p>
                </v-col>
                <v-col>
                  <p class="question mb-1">
                    삶의 이정표가 될 만한
                    <span class="subtitle-2">나의 롤모델</span>
                    은?
                  </p>
                  <p class="text-h6 mb-0 ans">{{ (this.master['Master-openEnded-3'] || {}).value || '' }}이다.</p>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row dense>
        <v-col>
          <v-card tile class="mt-0" flat>
            <div class="d-flex">
              <div class="section-title">My Life Style</div>
              <div class="section-title-border"></div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="3"></v-col>
        <v-col>지금까지 잘 이루어놓은 것은?</v-col>
        <v-col>지금까지 이루지 못해 아쉬운 것은?</v-col>
        <v-col>2nd Life에서 가장 자신 있는 것은?</v-col>
        <v-col>2nd Life에서 가장 위협적인 것은?</v-col>
      </v-row>
      <v-row class="life money">
        <v-col class="header-col" cols="3">
          <v-row class="cell top-border">
            <span class="text-left font-weight-bold keyword">돈</span>
            <span class="text-left">경제적 안정</span>
          </v-row>
        </v-col>
        <v-col style="padding: 0px 8px" v-for="(k, i) in order[0]" :key="k ? '1' + i : '8' + i + 'm'">
          <div class="content-cell" style="border-top: 1px solid grey"><v-icon x-large :color="orderColor[i]" v-if="k" class="icon-shadow">mdi-star</v-icon></div>
        </v-col>
      </v-row>
      <v-row class="life family">
        <v-col class="header-col" cols="3">
          <v-row class="cell">
            <span class="text-left font-weight-bold keyword">집</span>
            <span class="text-left">가족간 배려, 소통</span>
          </v-row>
        </v-col>
        <v-col style="padding: 0px 8px" v-for="(k, i) in order[1]" :key="k ? '2' + i : '7' + i + 'k'">
          <div class="content-cell"><v-icon x-large :color="orderColor[i]" v-if="k" class="icon-shadow">mdi-star</v-icon></div>
        </v-col>
      </v-row>
      <v-row class="life work">
        <v-col class="header-col" cols="3">
          <v-row class="cell">
            <span class="text-left font-weight-bold keyword">일</span>
            <span class="text-left">전문성/ 직업의 연속성</span>
          </v-row>
        </v-col>
        <v-col style="padding: 0px 8px" v-for="(k, i) in order[2]" :key="k ? '3' + i : '6' + i + 'l'">
          <div class="content-cell"><v-icon x-large :color="orderColor[i]" v-if="k" class="icon-shadow">mdi-star</v-icon></div>
        </v-col>
      </v-row>
      <v-row class="life friend">
        <v-col class="header-col" cols="3">
          <v-row class="cell">
            <span class="text-left font-weight-bold keyword">벗</span>
            <span class="text-left">외롭지 않는 삶. 네트웍</span>
          </v-row>
        </v-col>
        <v-col style="padding: 0px 8px" v-for="(k, i) in order[3]" :key="k ? '4' + i : '5' + i + 'o'">
          <div class="content-cell"><v-icon x-large :color="orderColor[i]" v-if="k" class="icon-shadow">mdi-star</v-icon></div>
        </v-col>
      </v-row>
      <v-row class="life joy">
        <v-col class="header-col" cols="3">
          <v-row class="cell">
            <span class="text-left font-weight-bold keyword">낙</span>
            <span class="text-left">즐거운 꺼리들</span>
          </v-row>
        </v-col>
        <v-col style="padding: 0px 8px" v-for="(k, i) in order[4]" :key="k ? '5' + i : '9' + i + 'p'">
          <div class="content-cell"><v-icon x-large :color="orderColor[i]" v-if="k" class="icon-shadow">mdi-star</v-icon></div>
        </v-col>
      </v-row>
      <v-row class="life health">
        <v-col class="header-col" cols="3">
          <v-row class="cell bottom-border">
            <span class="text-left font-weight-bold keyword">건강</span>
            <span class="text-left">몸과 마음의 건강</span>
          </v-row>
        </v-col>
        <v-col style="padding: 0px 8px" v-for="(k, i) in order[5]" :key="k ? 'a' + i : 'c' + i + 'u'">
          <div class="content-cell"><v-icon x-large :color="orderColor[i]" v-if="k" class="icon-shadow">mdi-star</v-icon></div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="mt-12">
          <v-card tile flat>
            <div class="d-flex">
              <div class="section-title">
                LIFE DESIGN Comments
                <span class="text-caption">Life</span>
              </div>
              <div class="section-title-border"></div>
            </div>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <template v-for="(t, i) in orderScore">
          <v-col cols="4" :key="t + '50'" class="">
            <div class="footer">
              <span class="">{{ i + 1 }}</span>
              <span class="">{{ getOrderStr(i + 1) }}</span>
              <v-spacer />
              <span class="text-h5 font-weight-bold">{{ t }}</span>
            </div>
          </v-col>
        </template>
      </v-row>
    </v-container>
    <v-footer padless color="transparent">
      <v-col class="text-center pa-0">
        <span class="caption">&copy;삼성금융경력컨설팅센터</span>
      </v-col>
    </v-footer>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapMutations, mapState } from 'vuex'

import SummaryHeader from './SummaryHeader.vue'
import SummaryTop from './SummaryTop.vue'
import SummaryName from './SummaryName.vue'
export default {
  components: { SummaryHeader, SummaryTop, SummaryName },
  name: 'Overview',
  data() {
    return {
      orderColor: ['secondary', 'orange darken-4', 'secondary', 'orange darken-4'],
    }
  },
  computed: {
    ...mapState(['master', 'userNick', 'userEmail']),
    orderScore() {
      //잘이루어놓은 것
      const g1 = this.master['Master-ordering-1'].list.map((o, i) => ({
        ...o,
        score: o.order,
      }))
      //위협적인것
      const t1 = this.master['Master-ordering-2'].list.map((o, i) => ({
        ...o,
        score: Math.abs(o.order - 7),
      }))

      // const g2 = _.keyBy(g1, 'title')
      const t2 = _.keyBy(t1, 'title')

      const sum = g1.map((k) => ({
        title: k.title,
        score: k.score + t2[k.title].score,
      }))
      console.log(g1, t1, t2, sum)
      return _.orderBy(sum, ['score'], ['desc'])
        .slice(0, 3)
        .map((o) => o.title)
    },
    order() {
      // this.setExample()
      //잘이루어놓은 것
      const g1 = _.orderBy(this.master['Master-ordering-1'].list, ['order'], ['asc'])

      const k = [
        [false, false, false, false],
        [false, false, false, false],
        [false, false, false, false],
        [false, false, false, false],
        [false, false, false, false],
        [false, false, false, false],
      ]
      const g = {
        돈: 0,
        집: 1,
        일: 2,
        벗: 3,
        낙: 4,
        건강: 5,
      }

      //위협적인 것
      const t1 = _.orderBy(this.master['Master-ordering-2'].list, ['order'], ['asc'])
      // console.log(g1,t1)
      console.log(g1[0].title, g1[5].title, t1[0].title, t1[1].title, t1[5].title, t1[4].title)
      k[g[g1[0].title]][0] = true
      k[g[g1[1].title]][0] = true
      k[g[g1[4].title]][1] = true
      k[g[g1[5].title]][1] = true
      k[g[t1[5].title]][2] = true
      k[g[t1[4].title]][2] = true
      k[g[t1[0].title]][3] = true
      k[g[t1[1].title]][3] = true
      return k
    },
  },
  methods: {
    getOrderStr(n) {
      if (n == 1) return 'st'
      if (n == 2) return 'nd'
      if (n == 3) return 'rd'
    },
  },
}
</script>

<style lang="scss" scoped>
.page {
  position: relative;
  border: 1px solid white;
  // width: 2480px;
  // height: 3508px;
  width: 21cm;
  height: 29.7cm;
  margin: auto;
  page-break-before: always;

  // @media print {
  //   body {
  //     width: 21cm;
  //     height: 29.7cm;
  //     margin: 30mm 45mm 30mm 45mm;
  //     /* change the margins as you want them to be. */
  //   }
  // }

  .contents {
    // border-top: 1px solid black;
    margin-top: 113px + 119px + 20px;
    height: 1070px - 113px - 119px;
    padding: 0 40px;

    .section-title {
      padding-top: 0px;
      font-weight: 900;
      font-size: 18px;
      height: 18px;
      color: #1c5eaa;
      font-family: 'SamsungSans';
    }
    .section-title-border {
      height: 20px;
      margin-left: 10px;
      flex-grow: 1;
      border-bottom: 1px solid #165caa;
    }
    .ans {
      height: 70px;
      color: black;

      display: -webkit-box;
      -webkit-line-clamp: 3; /* 라인수 */
      -webkit-box-orient: vertical;
      white-space: normal;
      line-height: 1.3em;
      max-height: 4em;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    .top-border {
      border-top: 3px solid grey;
    }
    .bottom-border {
      border-bottom: 3px solid grey !important;
    }
    .header-col {
      border-right: 1px solid grey;
      padding: 0px 12px;
      .cell {
        padding: 10px 0px;
        border-bottom: 1px solid grey;
        line-height: 40px;
      }
    }
    .row.cell {
      margin: 0px 0px;
      font-size: 12px;
    }
    .content-cell {
      padding: 10px 0px;
      height: 62px;
      border-bottom: 1px solid grey;
    }
    .icon-shadow {
      // text-shadow: 0px 0px 10px rgb(0 0 0 / 43%);
    }
    span.keyword {
      font-size: 16px;
      margin-right: 8px;
    }
    .cell2 {
      width: 100%;
    }
    .left-border {
      border-left: 2px solid grey;
    }
    .life-top {
      font-size: 1em;
    }
    .life-title > span {
      line-height: 50px;
      vertical-align: bottom;
    }
    .header-top {
      border-bottom: 3px solid grey !important;
    }
    .life {
      text-align: center;
      min-height: 64px;
    }
    .life-footer {
      margin-top: 20px;
    }
  }
  .footer {
    border-bottom: 1px solid grey;
    display: flex;
    align-items: flex-end;
    span {
      display: inline-block;
    }
  }
}
</style>
